export const COLUMN_OPTIONS = (t) => {
  return {
    column1: {
      name: t("analysisColumn.date"),
      key: "date",
    },
    column2: {
      name: t("analysisColumn.permeateflowrate"),
      unit: "flow",
      key: "permeate_flowrate",
    },
    column5: {
      key: "column5",
      options: {
        option1Text: {
          name: t("analysisColumn.feedFlowrate"),
          unit: "flow",
          key: "feed_flowrate",
        },
        option2Text: {
          name: t("analysisColumn.concentrateFlowrate"),
          unit: "flow",
          key: "concentrate_flowrate",
        },
      },
    },
    column4: {
      name: t("analysisColumn.permeatePressure"),
      unit: "pressure",
      key: "permeate_pressure",
    },
    column7: {
      name: t("analysisColumn.feedPressure"),
      unit: "pressure",
      key: "feed_pressure",
    },
    column6: {
      name: t("analysisColumn.permeateQuality"),
      unit: "permeate_quality",
      key: "permeate_quality",
    },

    column9: {
      name: t("analysisColumn.feedQuality"),
      unit: "feed_quality",
      key: "feed_quality",
    },

    column8: {
      key: "column8",
      options: {
        option1Text: {
          name: t("analysisColumn.pressureDrop"),
          unit: "pressure",
          key: "pressure_drop",
        },
        option2Text: {
          name: t("analysisColumn.concentratePressure"),
          unit: "pressure",
          key: "concentrate_pressure",
        },
      },
    },

    column3: {
      name: t("analysisColumn.feedTemperature"),
      unit: "temperature",
      key: "feed_temp",
    },
  };
};

export const NORMALIZATION_COLUMN_OPTIONS = (t) => {
  return {
    column10: {
      name: t("analysisColumn.normalizedPermeateFlow"),
      unit: "flow",
      key: "norm_permeate_flow",
    },
    column11: {
      name: t("analysisColumn.normalizedPressureDrop"),
      unit: "pressure",
      key: "norm_pressure_drop",
    },
    column12: {
      name: t("analysisColumn.normalizedSaltPassage"),
      key: "norm_salt_passage",
    },
  };
};

export const createArray = (number, key, create) => {
  let arr = [];
  if (create !== "") {
    if (key === "sel_stage") arr.push("All");
    if (number) {
      for (let i = 1; i <= number; i++) {
        arr.push(i.toString());
      }
    } else arr.push("1");
  }
  return arr;
};

export const TRAIN_OPTIONS = (t, config, selectedTrain, selectedPass) => {
  return {
    Pass: {
      name: t("addNewPlant.pass"),
      key: "sel_pass",
      options:
        selectedTrain !== ""
          ? createArray(
              config?.trains[selectedTrain].passes.length,
              "sel_pass",
              selectedTrain
            )
          : [],
      isSelect: true,
    },

    Stage: {
      name: t("addNewPlant.stage"),
      key: "sel_stage",
      options:
        selectedPass !== ""
          ? createArray(
              config?.trains[selectedTrain].passes[selectedPass].stages.length,
              "sel_stage",
              selectedPass
            )
          : [],
      isSelect: true,
    },
    pressureVessels: {
      name: t("addNewPlant.noPressureVessel"),
      key: "sel_pressure_vessels",
    },
    elementsInvolved: {
      name: t("addNewPlant.noElementsInvolved"),
      key: "sel_element_involved",
    },
    elementsType: {
      name: t("addNewPlant.elementType"),
      key: "sel_element_type",
    },
  };
};
export const REFERENCE_CONDITION_OPTIONS = (t, selectedRadioColumn) => {
  return [
    // default to feedFlowrate
    {
      name:
        selectedRadioColumn?.column5 === "concentrate_flowrate"
          ? t("referenceConditions.concentrateFlowrate")
          : t("referenceConditions.feedFlowrate"),
      unit: "flow",
      key:
        selectedRadioColumn?.column5 === "concentrate_flowrate"
          ? "concentrate_flowrate"
          : "feed_flowrate",
      ranges: {
        hard: { min: 0.01, max: 10000 },
      },
      defaultUnit: "m³/h",
    },
    {
      name: t("referenceConditions.feedPressure"),
      unit: "pressure",
      key: "feed_pressure",
      ranges: {
        hard: { min: 0.01, max: 80 },
      },
      defaultUnit: "bar",
    },
    {
      name: t("referenceConditions.feedQuality"),
      unit: "feed_quality",
      key: "feed_quality",
      ranges: {
        hard: { min: 0.01, max: 100000 },
      },
      defaultUnit: "µS/cm",
    },
    {
      name: t("referenceConditions.feedTemperature"),
      unit: "temperature",
      key: "feed_temp",
      ranges: {
        hard: { min: 0.01, max: 45 },
      },
      defaultUnit: "°C",
    },
    {
      name: t("referenceConditions.permeateFlowrate"),
      unit: "flow",
      key: "permeate_flowrate",
      ranges: {
        hard: { min: 0.01, max: 10000 },
      },
      defaultUnit: "m³/h",
    },
    {
      name: t("referenceConditions.permeatePressure"),
      unit: "pressure",
      key: "permeate_pressure",
      ranges: {
        hard: { min: 0.01, max: 5 },
      },
      defaultUnit: "bar",
    },
    {
      name: t("referenceConditions.permeateQuality"),
      unit: "permeate_quality",
      key: "permeate_quality",
      ranges: {
        hard: { min: 0.01, max: 10000 },
      },
      defaultUnit: "µS/cm",
    },
    {
      // default to concentrate_pressure
      name:
        selectedRadioColumn?.column8 === "pressure_drop"
          ? t("referenceConditions.pressureDrop")
          : t("referenceConditions.concentratePressure"),
      unit: "pressure",
      key:
        selectedRadioColumn?.column8 === "pressure_drop"
          ? "pressure_drop"
          : "concentrate_pressure",
      ranges: {
        hard: {
          min: 0.01,
          max: selectedRadioColumn?.column8 === "pressure_drop" ? 10 : 80,
        },
      },
      defaultUnit: "bar",
    },
  ];
};
